import { useCallback, useState } from "react"

import { Ipad } from "../../core/_models"
import { removeServiceFromIpadByUniqueIdentifier } from "../../core/_requests";
import { useAxios, APIError } from "../../core/_axios";
import ModalSendServiceToIpad from "../../components/ModalSendServiceToIpad";
import useLocalizedCopy from "../../hooks/useLocalizedCopy";

export function ManageServiceForm({
    iPad,
    setIpad
}: {
    iPad: Ipad,
    setIpad: (ipad: Ipad) => void
}) {
    const axios = useAxios();
    const { copy } = useLocalizedCopy();

    const [removingService, setRemovingService] = useState(false);
    const [errorRemovingService, setErrorRemovingService] = useState<string | null>(null);

    const [sendingServiceToIpadModalOpen, setSendingServiceToIpadModalOpen] = useState(false);

    const onRemoveService = useCallback(async () => {
        if (removingService) {
            return;
        }
        setErrorRemovingService(null);
        setRemovingService(true);
        try {
            const updatedIpad = await removeServiceFromIpadByUniqueIdentifier(axios, iPad.unique_identifier);
            setIpad(updatedIpad);
        } catch (exception) {
            console.error(exception)
            const errorMessage = exception instanceof APIError ? exception.message : copy.Common.messages.errorOccurred
            setErrorRemovingService(errorMessage)
        } finally {
            setRemovingService(false)
        }
    }, [removingService, axios, iPad.unique_identifier, setIpad])

    if (!iPad) {
        return null
    }

    return <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 lg:gap-7.5">
        <div className="col-span-2">
            <div className="flex flex-col gap-5 lg:gap-7.5">
                <div className="card">
                    <div className="card-header">
                        <h3 className="card-title">
                            {iPad.active_service ? copy.IPads.manage.endService : copy.IPads.manage.sendService}
                        </h3>
                    </div>
                    {iPad.active_service ? <>
                        <div className="card-body grid gap-7.5 py-5 lg:py-7.5">
                            <div>
                                <p>
                                    {`The service `}
                                    <strong>
                                        {`${iPad.active_service.public_data.deceased_person.full_name}`}
                                    </strong>
                                    {` is currently active on `}
                                    <strong>
                                        {`${iPad.public_data.ipad_name}`}
                                    </strong>
                                </p>
                                <p className="mt-5">
                                    {`Would you like to end `}
                                    <strong>
                                        {`${iPad.active_service.public_data.deceased_person.full_name}'s service`}
                                    </strong>
                                    {` on this iPad?`}
                                </p>
                            </div>
                        </div>
                        <div className="card-footer py-3.5 flex flex-col lg:flex-row items-center justify-between">
                            <div>
                                {errorRemovingService && <div className="text-red-500 text-sm font-medium">{errorRemovingService}</div>}
                            </div>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    disabled={removingService}
                                    onClick={onRemoveService}
                                >
                                    {!removingService ? copy.IPads.manage.endService : `${copy.IPads.manage.endService}...`}
                                </button>
                            </div>
                        </div>
                    </> : <>
                        <div className="card-body grid gap-7.5 py-5 lg:py-7.5">
                            <div>
                                <button className="btn btn-lg btn-light" onClick={() => {
                                    setSendingServiceToIpadModalOpen(true)
                                }}>
                                    {copy.IPads.manage.sendService}
                                </button>
                            </div>
                        </div>
                        <ModalSendServiceToIpad
                            active={sendingServiceToIpadModalOpen}
                            setActive={setSendingServiceToIpadModalOpen}
                            iPad={iPad}
                            setIpad={setIpad}
                        />
                    </>}
                </div>
            </div>
        </div>
    </div>
}